import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "text-2xl font-bold text-black-main mr-auto mt-auto mb-auto" }
const _hoisted_3 = { class: "text-gray-guide text-xs mt-1" }
const _hoisted_4 = { class: "container my-6" }
const _hoisted_5 = { class: "text-sm leading-4 tracking-tight text-portal-darkgrey" }
const _hoisted_6 = { class: "my-4 py-4 px-5 rounded-xl bg-black-secondary text-white" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "text-base font-medium" }
const _hoisted_9 = { class: "font-bold text-2xl mt-3 text-white" }
const _hoisted_10 = { class: "text-sm opacity-70" }
const _hoisted_11 = { class: "container my-6" }
const _hoisted_12 = { class: "text-sm leading-4 tracking-tight text-portal-darkgrey mb-4" }
const _hoisted_13 = { class: "container my-6" }
const _hoisted_14 = { class: "text-sm leading-4 tracking-tight text-portal-darkgrey" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "flex flex-1 mr-4" }
const _hoisted_17 = { class: "text-gray-currency" }
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = { class: "flex flex-1 mr-4" }
const _hoisted_20 = { class: "text-gray-currency" }
const _hoisted_21 = {
  key: 0,
  class: "text-portal-error text-xs"
}
const _hoisted_22 = {
  key: 1,
  class: "text-portal-darkgrey text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_CpsNumberInput = _resolveComponent("CpsNumberInput")!
  const _component_CpsButton = _resolveComponent("CpsButton")!
  const _component_CpsGuideModal = _resolveComponent("CpsGuideModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.t("Deposit_Title")), 1),
      _createElementVNode("button", {
        class: "flex flex-col items-center",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowGuideModal = true))
      }, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "info-icon" }, null, -1)),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("Deposit_Guide")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t("Deposit_Current_Rate")), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["circle", _ctx.fromCurrenyRateIcon])
          }, null, 2),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.fromCurrecnyName), 1)
        ]),
        _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.amountFormat(6)(_ctx.rate)), 1),
        _createElementVNode("p", _hoisted_10, "1 " + _toDisplayString(_ctx.fromCurrecnyName) + " = " + _toDisplayString(_ctx.amountFormat(2)(_ctx.rate)) + " " + _toDisplayString(_ctx.toCurrencyName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.t("Deposit_Transfer_Network")), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTokenStandard, (standard) => {
        return (_openBlock(), _createElementBlock("div", {
          key: standard.name,
          class: "inline-block mr-4"
        }, [
          _createVNode(_component_RadioButton, {
            item: standard,
            modelValue: _ctx.tokenStandard,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tokenStandard) = $event))
          }, null, 8, ["item", "modelValue"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.t("Deposit_Transfer")), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["mt-4 mb-2 py-4 rounded-md border border-solid border-amount", {'border-error': !_ctx.isValid && !_ctx.formGroup.pristine}])
      }, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: _normalizeClass(["circle mx-4", _ctx.fromCurrenyInputIcon])
          }, null, 2),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_CpsNumberInput, {
              value: _ctx.fromAmount,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fromAmount) = $event)),
              class: _normalizeClass({'text-gray-focus' : _ctx.grayTextSwitch}),
              name: "fromAmount",
              required: "",
              disabled: _ctx.rate === 0,
              precision: _ctx.decimalPlaces,
              onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.grayTextSwitch = _ctx.grayTextSwitch ? !_ctx.grayTextSwitch : _ctx.grayTextSwitch))
            }, null, 8, ["value", "class", "disabled", "precision"]),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.fromCurrecnyName), 1)
          ])
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "line" }, null, -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", {
            class: _normalizeClass(["box mx-4", _ctx.toCurrenyInputIcon])
          }, null, 2),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_CpsNumberInput, {
              value: _ctx.toAmount,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.toAmount) = $event)),
              class: _normalizeClass({'text-gray-focus' : !_ctx.grayTextSwitch}),
              name: "toAmount",
              disabled: _ctx.rate === 0,
              required: "",
              precision: 2,
              onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.grayTextSwitch = _ctx.grayTextSwitch ? _ctx.grayTextSwitch: !_ctx.grayTextSwitch))
            }, null, 8, ["value", "class", "disabled"]),
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.toCurrencyName), 1)
          ])
        ])
      ], 2),
      (!_ctx.formGroup.pristine && !_ctx.isValid)
        ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.t("Deposit_Transaction_Limit", { min: _ctx.formattedMinLimit, max: _ctx.formattedMaxLimit, currency: _ctx.toCurrencyName })), 1))
        : _createCommentVNode("", true),
      (_ctx.isShowKVND)
        ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.t("Deposit_Show_VND_Rate")), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_CpsButton, {
      class: "w-full",
      disabled: !_ctx.isValid,
      onClick: _ctx.submit
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("Deposit_Submit")), 1)
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    _createVNode(_component_CpsGuideModal, {
      isShowModal: _ctx.isShowGuideModal,
      guideContent: _ctx.guideContent,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowGuideModal = false))
    }, null, 8, ["isShowModal", "guideContent"])
  ]))
}